import React, { lazy } from "react";

import { VIEW_PANEL_UPGRADE_PACKAGES } from "constants/permissions";

const OtaHmacPage = lazy(() => import("./OtaHmacPage"));

const otaHmacRoute = {
  path: "packages.ota.hmac",
  element: <OtaHmacPage />,
  root: false,
  permission: VIEW_PANEL_UPGRADE_PACKAGES,
};

export default otaHmacRoute;
